import { BreadCrumbProvider } from '../../component/ui/breadcrumb'
import React, { useEffect } from 'react'
import { Layout } from './Layout'
import { useDispatch, useSelector } from 'react-redux'
import { getEmailTemplatesDropdown, getEmployeeInfo, getInvestorsDropdown, getSchemesDropdown, getSchemesDropdownAssignedToEmployee } from '../../utils/util'
import { setAllSchemeDetails } from '../../context/actions/allSchemeDetailsAction'
import { setAllInvestorDetails } from '../../context/actions/allInvestorDetailsAction'
import { setAllEmailTemplateDetails } from '../../context/actions/allEmailTemplateDetailsAction'
import { loaderSet } from '../../context/actions/loaderAction'
import { setEmployeeInfo } from '../../context/actions/employeeInfoAction'

const Employee = () => {

  const dispatch=useDispatch()
  const userInfo=useSelector(state=>state.user)
  const allSchemeDetails=useSelector(state=>state.allSchemeDetails)
  const handleGetEmployeeInfo=async()=>{
    dispatch(loaderSet(true))
    const payload={
      user_email: userInfo?.email,
      user_type: userInfo?.user_type,
      user_id: userInfo?.user_id
    }
    // const payload ={
    //   user_id:"user_e5e2e3cf",
    //   user_type:"employee",
    //   user_email:"madhankumarraja6@bot2do.com"
    // }

    try {
      const response=await getEmployeeInfo(payload)
      console.log("respose for employee info ",response)
      if(response){
       
        dispatch(loaderSet(false))
        dispatch(setEmployeeInfo(response?.data))
      }
    } catch (error) {
      console.log("error in view employe info api",error)
    }
  }

  const employeeInfo=useSelector(state=>state.employeeInfo)

  const getAllSchemeDetails=async()=>{
    const payload={
      schemeData:employeeInfo?.schemes
    }
    try {
      const response =await getSchemesDropdownAssignedToEmployee(payload)
      if(response && response?.data){
        console.log("response for gett all schemes dropdown from admin index.js file ",response.data)
        dispatch(setAllSchemeDetails(response?.data));
      }
    } catch (error) {
      console.log("Error in get all schemes dropdown ",error)
    }
  }

  const getAllInvestorDetails=async()=>{
    const payload={
      // user_type:userInfo && userInfo.user_type
         user_type:"investor"
    }
    try {
      const response=await getInvestorsDropdown(payload)
      if(response){
        dispatch(setAllInvestorDetails(response?.data))
      }
    } catch (error) {
      console.log("Error in get all investor dropdown ",error)
    }
  }


  const getAllEmailTemplateDetails=async()=>{
    try {
      const response =await getEmailTemplatesDropdown()
      console.log("response for gett all Email Template dropdown from admin index.js file ",response.data)
      if(response){
        dispatch(setAllEmailTemplateDetails(response.data));
      }
    } catch (error) {
      console.log("Error in get all Email Temaplate dropdown ",error)
    }
  }



  useEffect(()=>{
    handleGetEmployeeInfo()
    // getAllSchemeDetails()
    getAllInvestorDetails()
    getAllEmailTemplateDetails()
  },[])

  useEffect(()=>{
    if(allSchemeDetails===null){
      getAllSchemeDetails()
    }
      },)
  return (
    <BreadCrumbProvider>
    <Layout/>
   
    </BreadCrumbProvider>
  )
}

export default Employee
